import styled, { css, keyframes } from 'styled-components';
import { InputTag } from 'components/Input/styles';
import Button from 'components/Button';
import {
  black,
  border1,
  boxShadow1,
  exactWhite,
  gray,
} from '../../../../utils/style/colors';

export const PermissionSchemesContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
`;

export const PermissionSchemesForm = styled('form')`
  flex: none;
  display: flex;
  flex-direction: column;
  color: ${black};
`;

export const PermissionSchemesFormTitle = styled('div')`
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: bold;
`;

export const PermissionSchemeInputContainer = styled('div')`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: space-between;
`;

export const AddPermissionSchemeButton = styled(Button)`
  & > span {
    justify-content: center;
  }
`;

export const StyledInput = InputTag.withComponent('input');

const fadeItem = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const animationRule = css`
  ${fadeItem} cubic-bezier(0.075, 0.82, 0.165, 1) 0.5s;
`;

export const PermissionSchemesListContainer = styled('ul')`
  border-radius: 1rem;
  border: ${border1};
  display: flex;
  overflow: auto;
  //overflow: overlay;
  margin-top: 15px;
  box-shadow: ${boxShadow1};
  flex-direction: column;
  & > li {
    flex: none;
    display: block;
    padding: 10px 10px 10px 20px;
    position: relative;
    animation: ${animationRule};
    background: ${exactWhite};
    min-height: fit-content;
    align-items: center;
    border-bottom: 1px solid #dcdcdc;
  }
`;

export const PermissionSchemeDescription = styled('div')`
  color: var(--exact-white);
  font-size: 12px;
  font-weight: 400;
  //border: 1px solid ${gray};
`;

export const PermissionSchemeName = styled('div')`
  font-weight: 400;
`;

export const PermissionScheme = styled('div')`
  flex-grow: 1;
`;

interface ICardProps {
  margin?: string;
}
export const Card = styled('div')<ICardProps>`
  flex: 0.5;
  height: fit-content;
  margin: ${({ margin }) => margin || ' 1em'};
  display: flex;
  background: var(--exact-white);
  box-shadow: 0 3px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  flex-direction: column;
  padding: 10px;
  @media only screen and (max-width: 769px) {
    flex: none;
  }
  transition: all 0.5s;
`;
